import { RecentlyPlayedItem } from '@/store/slices/recentlyPlayed/recentlyPlayed';
import {
  EMBEDDED_MODE_QUERY,
  isEmbeddedQueryRequested,
} from '@/logic/embedded-mode';
import { resolveSameOriginMountPath } from '@/utilities/helpers/same-origin-path';

/** Keeps lobby embed mode when navigating to another game inside the iframe. */
const appendEmbeddedQueryParam = (url: string): string => {
  if (!isEmbeddedQueryRequested()) {
    return url;
  }

  const parsed = new URL(url, window.location.origin);
  parsed.searchParams.set(
    EMBEDDED_MODE_QUERY.EMBEDDED,
    EMBEDDED_MODE_QUERY.EMBEDDED_VALUE,
  );

  return parsed.toString();
};

/**
 * Game-window URL for a game uid: `{origin}{mount}/{uid}`, keeping
 * `/game-window-play` and `?embedded=1`. `undefined` when there is no uid.
 */
export const getGameUrl = (
  gameUid: string | null | undefined,
): string | undefined => {
  if (!gameUid) {
    return undefined;
  }

  const mountPath = resolveSameOriginMountPath(window.location.pathname) ?? '';
  const url = `${window.location.origin}${mountPath}/${encodeURIComponent(gameUid)}`;

  return appendEmbeddedQueryParam(url);
};

/**
 * Mirrors casino-game-launcher's `getRecentlyPlayedUrl`. Returns `undefined`
 * when the item has no `gameUid`.
 */
export const getRecentlyPlayedUrl = (
  item: RecentlyPlayedItem | null | undefined,
): string | undefined => getGameUrl(item?.gameUid);
